import { useState } from 'react';

import {
  EditableRow,
  ListItemButton,
  SettingsCard,
  SettingsRow,
  SettingsSection,
} from './settings-ui';

/**
 * Settings › Integrations (SCRUM-460): the referrals-widget card (allowed embed
 * domain + copy-able installation snippet) and the webhooks card (endpoint,
 * subscribed events, last delivery). Ports `renderSettingsSectionIntegrations`.
 *
 * DEMO-ERA SCOPE: the widget embed domain reuses the org support-phone-style
 * persistence pattern is NOT wired (there is no widget/webhook config backend in
 * this iteration); the snippet, subscribed-events pills, and last-delivery badge
 * are presentation from the prototype. Real widget/webhook config is future work.
 */

const INSTALL_SNIPPET =
  '<script src="https://cdn.intersect.com/bankiq/widget.js" data-tenant="tnt_meridian_242"></script>';

export function IntegrationsSection() {
  const [copied, setCopied] = useState(false);

  const copySnippet = () => {
    void navigator.clipboard.writeText(INSTALL_SNIPPET).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  };

  return (
    <SettingsSection>
      <SettingsCard title="Referrals widget">
        <EditableRow
          label="Allowed embed domain"
          value="banking.meridiancommunity.example"
          onSave={() => {
            /* Widget-config persistence is future work (no widget-config backend yet). */
          }}
        />
        <SettingsRow label="Installation snippet" className="items-start">
          <div className="flex flex-col items-stretch gap-2">
            <pre className="bg-bg-2 border-border-0 rounded-tk-sm text-text-1 m-0 overflow-x-auto px-3 py-2.5 font-mono text-[0.6875rem] whitespace-pre">
              {INSTALL_SNIPPET}
            </pre>
            <ListItemButton className="self-start" onClick={copySnippet}>
              {copied ? 'Copied' : 'Copy snippet'}
            </ListItemButton>
          </div>
        </SettingsRow>
      </SettingsCard>

      <SettingsCard
        title="Webhooks"
        headerRight={
          <span className="text-text-3 bg-bg-3 rounded-tk-full px-2 py-0.5 font-mono text-[0.5625rem] font-semibold tracking-[0.08em] uppercase">
            Tenant-scoped
          </span>
        }
      >
        <EditableRow
          label="Endpoint URL"
          value="https://core.meridiancommunity.example/webhooks/bankiq"
          onSave={() => {
            /* Webhook-config persistence is future work (no webhook-config backend yet). */
          }}
        />
        <SettingsRow label="Subscribed events" sub="3 of 8 enabled">
          <div className="flex items-center">
            {['campaign.exported', 'referral.created', 'referral.resolved'].map((evt) => (
              <span
                key={evt}
                className="bg-bg-3 border-border-0 rounded-tk-full text-text-1 ml-1 inline-flex items-center border px-2 py-0.5 font-mono text-[0.625rem] font-medium first:ml-0"
              >
                {evt}
              </span>
            ))}
          </div>
        </SettingsRow>
        <SettingsRow label="Last delivery">
          <span className="rounded-tk-sm inline-flex items-center border border-[rgba(34,178,110,0.30)] bg-[rgba(34,178,110,0.10)] px-2.5 py-0.5 font-mono text-[0.625rem] font-semibold tracking-[0.06em] text-[#22b26e] uppercase">
            200 OK · 4 min ago
          </span>
        </SettingsRow>
      </SettingsCard>
    </SettingsSection>
  );
}
